module.exports = __webpack_public_path__ + "static/media/search1.836fec0e.png";